export default __webpack_public_path__ + "static/media/show-umbrella-2.0b2d308c.webp";